import { render, staticRenderFns } from "./LocationTargetOffIcon.vue?vue&type=template&id=4a4c2887&scoped=true&"
import script from "./LocationTargetOffIcon.vue?vue&type=script&lang=js&"
export * from "./LocationTargetOffIcon.vue?vue&type=script&lang=js&"
import style0 from "./LocationTargetOffIcon.vue?vue&type=style&index=0&id=4a4c2887&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4c2887",
  null
  
)

export default component.exports